// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='InputSlider'] {\n  position: relative;\n  display: block;\n  background-color: var(--primary-header-bg);\n}\n  [name='InputSlider'] .value {\n    position: absolute;\n    background-color: var(--primary-style-color);\n    top: 0;\n    height: 100%;\n  }\n  [name='InputSlider'] .handle {\n    position: absolute;\n    left: 0 !important;\n    width: 100%;\n    height: 100%;\n  }\n", ""]);
// Exports
module.exports = exports;
